import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue";
import _imports_0 from '../assets/pbl/img/close_btn.png';
const _hoisted_1 = {
  class: "pblWindow"
};
const _hoisted_2 = {
  class: "blueTitleName"
};
const _hoisted_3 = {
  id: "containRelics",
  ref: "contain"
};
const _hoisted_4 = {
  key: 0,
  class: "360Img"
};
const _hoisted_5 = {
  class: "imgbox",
  id: "imgbox"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = ["value"];
const _hoisted_8 = {
  key: 2,
  class: "containRelicsImg"
};
const _hoisted_9 = {
  class: "imagslist"
};
const _hoisted_10 = {
  class: "swiper-container swiperImg",
  ref: "swiperImg"
};
const _hoisted_11 = {
  class: "swiper-wrapper"
};
const _hoisted_12 = {
  class: "swiper-slide"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  class: "swiper-button-next swiper-button-white"
};
const _hoisted_15 = {
  class: "swiper-button-prev swiper-button-white"
};
const _hoisted_16 = {
  class: "containRelicsVideo"
};
const _hoisted_17 = ["src"];
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  key: 4,
  id: "loadbar1"
};
const _hoisted_20 = ["innerHTML"];
const _hoisted_21 = {
  class: "zhuantiCode",
  ref: "zhuantiCode"
};
const _hoisted_22 = {
  key: 0,
  class: "list"
};
const _hoisted_23 = ["src"];
const _hoisted_24 = {
  class: "tips"
};
const _hoisted_25 = {
  class: "titleCode"
};
const _hoisted_26 = {
  class: "title"
};
const _hoisted_27 = {
  class: "titleName"
};
const _hoisted_28 = {
  id: "qrcode",
  ref: "erWeiMaCode"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: "modelPlaceholder",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.hideModel && $options.hideModel(...args))
  }), _createElementVNode("div", {
    class: "model",
    style: _normalizeStyle(`top: ${$data.endMoveY ? $data.endMoveY : $data.boxTop}px`),
    ref: "model",
    onTouchstart: _cache[10] || (_cache[10] = (...args) => $options.modeltouchstart && $options.modeltouchstart(...args)),
    onTouchmove: _cache[11] || (_cache[11] = (...args) => $options.modeltouchmove && $options.modeltouchmove(...args))
  }, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, _toDisplayString($props.modelData.name), 1), _createElementVNode("img", {
    src: _imports_0,
    onClick: _cache[1] || (_cache[1] = (...args) => $options.hideModel && $options.hideModel(...args))
  })]), _createElementVNode("div", {
    class: "close",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.hideModel && $options.hideModel(...args))
  }), _createElementVNode("div", {
    class: "contain",
    id: "contain3D",
    style: _normalizeStyle($props.modelData.type == '360' ? 'z-index: 0' : '')
  }, [_withDirectives(_createElementVNode("div", _hoisted_3, [$props.modelData.type == '360' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.detail.images360, item => {
    return _openBlock(), _createElementBlock("li", null, [_createElementVNode("img", {
      src: item
    }, null, 8, _hoisted_6)]);
  }), 256))])]), _cache[12] || (_cache[12] = _createElementVNode("div", {
    id: "threesixty"
  }, [_createElementVNode("div", {
    id: "spinner"
  }, [_createElementVNode("span", null, "0%")]), _createElementVNode("ol", {
    id: "threesixty_images"
  })], -1))])) : _createCommentVNode("", true), $data.detail.images360 && $data.detail.images360.length ? (_openBlock(), _createElementBlock("input", {
    key: 1,
    type: "hidden",
    id: "360Number",
    value: $data.detail.images360.length
  }, null, 8, _hoisted_7)) : _createCommentVNode("", true), $data.detail.type == '图片' ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.detail.images, item => {
    return _openBlock(), _createElementBlock("div", _hoisted_12, [_createElementVNode("img", {
      src: item
    }, null, 8, _hoisted_13)]);
  }), 256))]), _withDirectives(_createElementVNode("div", _hoisted_14, null, 512), [[_vShow, $data.detail.images.length > 1]]), _withDirectives(_createElementVNode("div", _hoisted_15, null, 512), [[_vShow, $data.detail.images.length > 1]])], 512)])])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_16, [_createElementVNode("video", {
    controls: "",
    src: $data.detail.video
  }, null, 8, _hoisted_17)], 512), [[_vShow, $props.modelData.type == '视频']]), $props.modelData.type == '3D' ? (_openBlock(), _createElementBlock("iframe", {
    key: 3,
    frameborder: "0",
    border: "0",
    src: $props.detailUrl,
    width: "100%",
    height: "100%",
    style: _normalizeStyle(`z-index: ${$data.loadingIframe ? '-1' : '1'}`),
    id: "detailIframe"
  }, null, 12, _hoisted_18)) : _createCommentVNode("", true), $props.modelData.type == '3D' ? (_openBlock(), _createElementBlock("div", _hoisted_19, [...(_cache[13] || (_cache[13] = [_createElementVNode("span", {
    id: "bar1",
    style: {
      "width": "1%"
    }
  }, null, -1)]))])) : _createCommentVNode("", true)], 512), [[_vShow, $data.showDetail]]), _withDirectives(_createElementVNode("div", {
    id: "containIntroduce",
    onClick: _cache[3] || (_cache[3] = $event => $options.changeActive(0, 'blue'))
  }, [$data.activeIndex == 1 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "content",
    innerHTML: $data.detail.description
  }, null, 8, _hoisted_20)) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", _hoisted_21, null, 512), [[_vShow, $data.activeIndex == 2]])], 512), [[_vShow, !$data.showDetail]]), $data.detail.audio ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createElementVNode("div", {
    class: "introduce",
    onClick: _cache[4] || (_cache[4] = $event => $options.changeActive(1))
  }, [...(_cache[14] || (_cache[14] = [_createElementVNode("span", {
    id: "introduce"
  }, null, -1)]))]), _createElementVNode("div", {
    id: "but",
    class: _normalizeClass(!$data.isPause ? 'but' : 'butno'),
    onClick: _cache[5] || (_cache[5] = (...args) => $options.handelAudio && $options.handelAudio(...args))
  }, null, 2), _createElementVNode("audio", {
    id: "voice",
    src: $data.detail.audio,
    ref: "audioItem"
  }, null, 8, _hoisted_23)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", {
    class: _normalizeClass(`relics ${$data.activeIndex == 0 ? 'active' : ''}`),
    onClick: _cache[6] || (_cache[6] = $event => $options.changeActive(0))
  }, [...(_cache[15] || (_cache[15] = [_createElementVNode("span", {
    id: "relics"
  }, "文物", -1)]))], 2), _createElementVNode("div", {
    class: _normalizeClass(`introduce ${$data.activeIndex == 1 ? 'active' : ''}`),
    onClick: _cache[7] || (_cache[7] = $event => $options.changeActive(1))
  }, [...(_cache[16] || (_cache[16] = [_createElementVNode("span", {
    id: "introduce"
  }, "简介", -1)]))], 2), $data.detail.zhuanti ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: _normalizeClass(`special ${$data.activeIndex == 2 ? 'active' : ''}`),
    onClick: _cache[8] || (_cache[8] = $event => $options.changeActive(2))
  }, [...(_cache[17] || (_cache[17] = [_createElementVNode("span", {
    id: "special"
  }, " 专题", -1)]))], 2)) : _createCommentVNode("", true)])], 4), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, _toDisplayString($props.modelData.name), 1)])]), _ctx.$route.query.fid == 330431 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "like",
    onClick: _cache[9] || (_cache[9] = $event => $options.setRecord('', 'addLike'))
  }, _toDisplayString($data.detail.likeNum || 0), 1)) : _createCommentVNode("", true), _createElementVNode("div", {
    class: _normalizeClass(`code ${$data.activeIndex == 1 ? 'hideBlueCode' : ''}`)
  }, [_createElementVNode("div", _hoisted_28, null, 512)], 2)], 36)]);
}